import routesLimited, { hasProperty } from '@/constants/routesLimited'
import type { HideObject, RouteWithParams } from 'plugins/router/types'
import type { RouteRecordRaw } from 'vue-router'

export const hideCis: HideObject = {
	method: hasProperty,
	parameter: {
		store: 'setting',
		getter: 'getData',
		property: 'hide_cis',
		value: false,
	},
}
export const cisCreate: RouteRecordRaw = {
	component: () => import('components/modules/Cis/CisCreateEdit.vue'),
	name: 'cisCreate',
	path: '/cis/create',
	meta: {
		params: {
			mode: 'create',
			title: 'Z.I.S. anlegen',
		},
		limited: routesLimited.isAdminOrTeam,
		subs: [routesLimited.subModules.cis],
	},
}

export const cisUpdate: RouteRecordRaw = {
	component: () => import('components/modules/Cis/CisCreateEdit.vue'),
	name: 'cisUpdate',
	path: '/cis/:cisId/edit',
	meta: {
		params: {
			mode: 'edit',
		},
		title: 'Z.I.S. bearbeiten',
		limited: routesLimited.isAdminOrTeam,
		subs: [routesLimited.subModules.cis],
	},
}
